// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"O3-z","displaySixCardTiles":"P3-z"};